<if(input.pointsOfInterest && input.pointsOfInterest.length > 0)>
  <div class="items-carousel">
    <if(state.drawCarousel)>
      <ebay-carousel key="cool-carousel" gap=8 index=0 class="carousel-mapview">
        <for|item, index| of=input.pointsOfInterest>
          <@item>
            <map-item itemCard=item.itemCard key=String(index)/>
          </@item>
        </for>
      </ebay-carousel>
    </if>
  </div>
</if>
